import { SUPPORTED_LANGUAGES } from "@/lib/language";
import { Languages } from "lucide-react";

interface LanguageSwitcherProps {
  value: string;
  onChange: (code: string) => void;
}

/** Always-available header control to change the global chat language. */
export function LanguageSwitcher({ value, onChange }: LanguageSwitcherProps) {
  return (
    <label className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
      <Languages className="h-4 w-4" aria-hidden />
      <span className="sr-only">언어 선택 / Language</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-md border border-input bg-background px-2 py-1 text-xs text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/70"
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
